
import React, { Component } from "react";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import { setError, setSuccess, setLoader } from "../../../actions/action-creators";
import InputField from "../../global/form/input";
import ConfirmAction from "../../global/confirm-action";
import SelectList from "../../global/form/select";
import { Button, Chip, Icon, Input } from "@material-ui/core";
import moment from "moment";
import ReactDatePicker from "react-datepicker";
import DummyCompanyImage from "../../../assets/images/company-default.png";
import InvoicePreview from "./invoice_preview";
import CONSTANTS from "../../../constants";

class InvoiceCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clientList: [],
            jobList: [],
            invoiceData: this.props.invoiceData || { invoice_date: moment().toDate(), hsn_code: "998399", items: [] },
            selectedClient: {},
            clientInvoices: [],
            isPreview: this.props.isPreview || false
        };
    }


    async componentDidMount() {
        await this.fetchClients();

        let { invoiceData } = this.props;
        if (invoiceData) {
            if (invoiceData.client_id) {
                await this.getClientJobs(invoiceData.client_id);
                this.selectClient(invoiceData.client_id);
            }
            if (invoiceData.isCreditNote) this.fetchClientInvoices();
        }
    }

    fetchClients = async () => {
        store.dispatch(setLoader(true))
        try {
            let body = {};
            let apiData = await ApiEndpoints.Invoice.fetchClients(body);
            let clientList = apiData.data.data;
            this.setState({ clientList })
        }
        catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }))
        }
        store.dispatch(setLoader(false))
    }

    fetchClientInvoices = async () => {
        store.dispatch(setLoader(true))
        try {
            let { selectedClient } = this.state;
            let body = { client_id: selectedClient.client_id };
            let apiData = await ApiEndpoints.Invoice.fetchInvoice(body);
            let clientInvoices = apiData.data.data;
            this.setState({ clientInvoices })
        }
        catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }))
        }
        store.dispatch(setLoader(false))
    }


    getMonthsList = (startDate, endDate) => {
        if (!startDate || !endDate) return [];
        const start = moment(startDate).startOf("month");
        const end = moment(endDate).startOf("month");
        const list = [];
        const curr = start.clone();
        while (curr.isBefore(end) || curr.isSame(end, "month")) {
            list.push(curr.format("MMM 'YY"));
            curr.add(1, "month");
        }
        return list;
    }

    getCandidateMonths = (startDate, endDate) => {
        const monthsFromRange = this.getMonthsList(startDate, endDate);
        const setOfMonths = new Set(monthsFromRange);

        const baseYear = startDate ? moment(startDate).year() : moment().year();
        for (let m = 0; m < 12; m++) {
            setOfMonths.add(moment().year(baseYear).month(m).format("MMM 'YY"));
        }

        return Array.from(setOfMonths).sort((a, b) => {
            const tA = moment(a, "MMM 'YY").valueOf();
            const tB = moment(b, "MMM 'YY").valueOf();
            return tA - tB;
        });
    }

    sortMonthlyItemsChronologically = (monthlyItems) => {
        if (!monthlyItems) return [];
        return monthlyItems.sort((a, b) => {
            const hasA = a.start_date && moment(a.start_date).isValid();
            const hasB = b.start_date && moment(b.start_date).isValid();

            if (!hasA && hasB) return 1;
            if (hasA && !hasB) return -1;
            if (!hasA && !hasB) return 0;

            const tA = moment(a.start_date).valueOf();
            const tB = moment(b.start_date).valueOf();

            if (tA !== tB) {
                return tA - tB;
            }

            return String(a.entity_id !== undefined && a.entity_id !== null ? a.entity_id : "").localeCompare(String(b.entity_id !== undefined && b.entity_id !== null ? b.entity_id : ""));
        });
    }

    syncMonthlyItems = (invoiceData, forceRebuild = false) => {
        (invoiceData.items || []).forEach(item => {
            if (!item.monthly_items) item.monthly_items = [];
            this.sortMonthlyItemsChronologically(item.monthly_items);
        });
    }

    addMonthToItem = (itemIdx) => {
        let { invoiceData } = this.state;
        if (invoiceData.items[itemIdx]) {
            if (!invoiceData.items[itemIdx].monthly_items) invoiceData.items[itemIdx].monthly_items = [];

            invoiceData.items[itemIdx].monthly_items.push({
                month_label: "",
                start_date: null,
                end_date: null,
                entity_type: "JOB",
                entity_id: "",
                unit_cost: 0,
                user_onboarding: 0,
                amount: 0
            });

            this.recalculateTotals();
        }
    }

    // TODO: Unit cost calculation improvement needed.
    // Current approach: uses the most frequently occurring unit_cost across monthly_items as rate_per_item.
    // This is not always accurate — unit cost may change per month for the same job.
    //
    // Future plan: Add a "unit cost breakdown" option on the invoice.
    // - If all monthly unit costs are the same → no breakdown needed, display a single rate.
    // - If unit costs differ across months → show a per-month breakdown so the client can
    //   see exactly when and how the rate changed.
    // This gives full transparency on rate changes per billing period.
    getMostOccurringUnitCost = (monthlyItems) => {
        if (!monthlyItems || !monthlyItems.length) return 0;
        const frequencyMap = {};
        let maxCount = 0;
        let mostOccurringValue = 0;

        monthlyItems.forEach(m => {
            const cost = parseFloat(m.unit_cost) || 0;
            if (cost > 0) {
                frequencyMap[cost] = (frequencyMap[cost] || 0) + 1;
                if (frequencyMap[cost] > maxCount) {
                    maxCount = frequencyMap[cost];
                    mostOccurringValue = cost;
                }
            }
        });

        if (mostOccurringValue > 0) return mostOccurringValue;
        return parseFloat(monthlyItems[0].unit_cost) || 0;
    }

    recalculateTotals = () => {
        let { invoiceData } = this.state;
        (invoiceData.items || []).forEach(item => {
            if (item.monthly_items && item.monthly_items.length > 0) {
                let totalUsers = 0;
                let totalAmt = 0;
                item.monthly_items.forEach(m => {
                    m.amount = (parseFloat(m.unit_cost) || 0) * (parseInt(m.user_onboarding) || 0);
                    totalUsers += (parseInt(m.user_onboarding) || 0);
                    totalAmt += m.amount;
                });
                item.quantity = totalUsers;
                item.amount = totalAmt;
                item.rate_per_item = this.getMostOccurringUnitCost(item.monthly_items);
            } else {
                item.amount = (item.quantity || 0) * (item.rate_per_item || 0);
            }
        });
        invoiceData.taxable_amount = (invoiceData.items || []).filter(o => o.isActive !== false).reduce((total, item) => total + (item.amount || 0), 0);
        this.setState({ invoiceData });
    }

    onChangeInvoiceData = (k, v) => {
        let { invoiceData, clientInvoices, jobList } = this.state;
        if (k === "dates") {
            if (v === null) invoiceData.start_date = invoiceData.end_date = null;
            else if (invoiceData.start_date) invoiceData.end_date = moment(v).endOf("day").toDate();
            else {
                invoiceData.start_date = moment(v).startOf("day").toDate();
                invoiceData.end_date = moment(v).endOf("day").toDate();
            }
            this.syncMonthlyItems(invoiceData, true);
            this.recalculateTotals();
        }
        else invoiceData[k] = v;
        if (k === "client_id") {
            invoiceData.items = [];
        }
        if (k === "isCreditNote" && v) this.fetchClientInvoices();
        if (k === "credit_note_invoice_id") {
            let creditNotInvoice = clientInvoices.filter(invoice => invoice.invoice_id === parseInt(v))[0];
            invoiceData.creditNoteInvoice = creditNotInvoice;
        }

        this.setState({ invoiceData });
    }

    selectClient = (clientId) => {
        let { clientList } = this.state;
        let selectedClient = clientList.filter(client => client.client_id === parseInt(clientId))[0];
        this.onChangeInvoiceData("client_id", selectedClient.client_id);
        this.getClientJobs(selectedClient.client_id)
        this.setState({ selectedClient });
    }

    getClientJobs = async (clientId) => {
        store.dispatch(setLoader(true));
        let { invoiceData } = this.state;
        try {
            let apiData = await ApiEndpoints.Jobs.fetch();
            var jobList = apiData.data.data;
            var jobListSelectedClient = jobList.filter(job => job.client_id === clientId)
            if (!(invoiceData.items && invoiceData.items.length)) {
                invoiceData.items = [
                    {
                        entity_type: "JOB",
                        entity_id: "",
                        item_name: "",
                        isActive: true,
                        quantity: 0,
                        rate_per_item: 0,
                        amount: 0,
                        monthly_items: [
                            {
                                month_label: "",
                                start_date: null,
                                end_date: null,
                                entity_type: "JOB",
                                entity_id: "",
                                unit_cost: 0,
                                user_onboarding: 0,
                                amount: 0
                            }
                        ]
                    }
                ];
                invoiceData.taxable_amount = 0;
            }
            await this.setState({ jobList, jobListSelectedClient, invoiceData })
            this.syncMonthlyItems(invoiceData);
            this.recalculateTotals();
        }
        catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }))
        }
        store.dispatch(setLoader(false))
    }

    onChangeInvoiceItem = (i, k, v) => {
        let { invoiceData } = this.state;
        if (k === "entity_id") {
            if (v === "GENERAL") {
                invoiceData.items[i].entity_type = "GENERAL";
                invoiceData.items[i].entity_id = 0;
            } else {
                invoiceData.items[i].entity_type = "JOB";
                invoiceData.items[i].entity_id = v;
            }
            invoiceData.items[i].isEditTag = false;
        } else {
            invoiceData.items[i][k] = v;
        }
        this.recalculateTotals();
    }

    onChangeMonthlyItem = (itemIdx, monthIdx, field, val) => {
        let { invoiceData } = this.state;
        if (invoiceData.items[itemIdx] && invoiceData.items[itemIdx].monthly_items[monthIdx]) {
            const currentItem = invoiceData.items[itemIdx];
            const currentMonthlyItem = currentItem.monthly_items[monthIdx];

            if (field === "entity_id") {
                const targetEntityType = val === "GENERAL" ? "GENERAL" : "JOB";
                const targetEntityId = val === "GENERAL" ? 0 : val;

                // Guard: Prevent duplicate project / general entry for the same month
                if (currentMonthlyItem.month_label) {
                    const isDuplicate = (currentItem.monthly_items || []).some((m, idx) =>
                        idx !== monthIdx &&
                        m.month_label === currentMonthlyItem.month_label &&
                        (
                            (targetEntityType === "GENERAL" || targetEntityId === 0)
                                ? (m.entity_type === "GENERAL" || m.entity_id === 0)
                                : String(m.entity_id) === String(targetEntityId)
                        )
                    );
                    if (isDuplicate) {
                        store.dispatch(setError({ show: true, message: `This ${targetEntityType === "GENERAL" ? "General Entry" : "project"} is already added for ${currentMonthlyItem.month_label}` }));
                        return;
                    }
                }

                currentMonthlyItem.entity_type = targetEntityType;
                currentMonthlyItem.entity_id = targetEntityId;
            } else if (field === "month_label") {
                // Guard: Prevent duplicate month for the same project / general entry
                if (val && currentMonthlyItem.entity_id !== undefined && currentMonthlyItem.entity_id !== "") {
                    const isDuplicate = (currentItem.monthly_items || []).some((m, idx) =>
                        idx !== monthIdx &&
                        m.month_label === val &&
                        (
                            (currentMonthlyItem.entity_type === "GENERAL" || currentMonthlyItem.entity_id === 0)
                                ? (m.entity_type === "GENERAL" || m.entity_id === 0)
                                : String(m.entity_id) === String(currentMonthlyItem.entity_id)
                        )
                    );
                    if (isDuplicate) {
                        store.dispatch(setError({ show: true, message: `${val} is already added for this ${currentMonthlyItem.entity_type === "GENERAL" ? "General Entry" : "project"}` }));
                        return;
                    }
                }

                currentMonthlyItem.month_label = val;
                // Auto-set start_date and end_date to first and last day of the selected month
                if (val) {
                    currentMonthlyItem.start_date = moment(val, "MMM 'YY").startOf("month").format("YYYY-MM-DD");
                    currentMonthlyItem.end_date = moment(val, "MMM 'YY").endOf("month").format("YYYY-MM-DD");
                } else {
                    currentMonthlyItem.start_date = null;
                    currentMonthlyItem.end_date = null;
                }
                this.sortMonthlyItemsChronologically(currentItem.monthly_items);
            } else {
                currentMonthlyItem[field] = val;
            }
            this.recalculateTotals();
        }
    }

    onChangeMonthDateRange = (itemIdx, monthIdx, dates) => {
        let { invoiceData } = this.state;
        const mItem = invoiceData.items[itemIdx] && invoiceData.items[itemIdx].monthly_items[monthIdx];
        if (!mItem) return;

        if (dates === null) {
            // Cleared - reset to full month defaults
            if (mItem.month_label) {
                mItem.start_date = moment(mItem.month_label, "MMM 'YY").startOf("month").format("YYYY-MM-DD");
                mItem.end_date = moment(mItem.month_label, "MMM 'YY").endOf("month").format("YYYY-MM-DD");
            } else {
                mItem.start_date = null;
                mItem.end_date = null;
            }
        } else {
            // Is it the start of a new range?
            if (mItem.start_date && mItem.end_date && mItem.start_date !== mItem.end_date) {
                // New range start
                mItem.start_date = moment(dates).format("YYYY-MM-DD");
                mItem.end_date = moment(dates).format("YYYY-MM-DD");
            } else if (mItem.start_date) {
                // Second click of a new range
                if (moment(dates).isBefore(moment(mItem.start_date))) {
                    mItem.end_date = mItem.start_date;
                    mItem.start_date = moment(dates).format("YYYY-MM-DD");
                } else {
                    mItem.end_date = moment(dates).format("YYYY-MM-DD");
                }
            } else {
                // Initial selection if everything was null
                mItem.start_date = moment(dates).format("YYYY-MM-DD");
                mItem.end_date = moment(dates).format("YYYY-MM-DD");
            }
        }

        this.setState({ invoiceData });
    }

    removeMonthlyItem = (itemIdx, monthIdx) => {
        let { invoiceData } = this.state;
        if (invoiceData.items[itemIdx] && invoiceData.items[itemIdx].monthly_items) {
            invoiceData.items[itemIdx].monthly_items.splice(monthIdx, 1);
            this.recalculateTotals();
        }
    }

    removeInvoiceItem = (item, i) => {
        let { invoiceData } = this.state;
        invoiceData.items.splice(i, 1);
        this.recalculateTotals();
    }

    previewInvoice = () => {
        let { invoiceData } = this.state;
        if (!this.state.isPreview) {
            if (!invoiceData.client_id) {
                store.dispatch(setError({ show: true, message: "Please select a client first" }));
                return;
            }
            // Check that every card has an Invoice Description
            const missingDescription = (invoiceData.items || []).some(item => !item.item_name || !item.item_name.trim());
            if (missingDescription) {
                store.dispatch(setError({ show: true, message: "Please provide an Invoice Description for all items" }));
                return;
            }
            if (!invoiceData.taxable_amount || invoiceData.taxable_amount <= 0) {
                store.dispatch(setError({ show: true, message: "Please add valid invoice items with onboardings and unit cost" }));
                return;
            }
        }
        this.setState({ isPreview: !this.state.isPreview })
    }

    onInvoiceAdd = () => {
        this.props.onClose(true);
    }

    appendNewInvoiceItem = () => {
        let { invoiceData } = this.state;
        let newMonthlyItems = [{
            month_label: "",
            start_date: null,
            end_date: null,
            entity_type: "JOB",
            entity_id: "",
            unit_cost: 0,
            user_onboarding: 0,
            amount: 0
        }];
        let item = { item_name: "", entity_type: "JOB", entity_id: "", rate_per_item: 0, quantity: 0, amount: 0, isActive: true, monthly_items: newMonthlyItems };
        invoiceData.items.push(item);
        this.recalculateTotals();
    }

    render() {
        let { clientList, invoiceData, selectedClient, jobList, clientInvoices, isPreview } = this.state;

        return isPreview ? <InvoicePreview invoiceData={invoiceData} selectedClient={selectedClient} jobList={jobList} onInvoiceAdd={this.onInvoiceAdd} onClose={this.previewInvoice} /> : (
            <div className="h-100" style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", overflowX: "hidden" }}>

                <main className="h-100 p-3" style={{ overflowY: "auto", overflowX: "hidden", fontSize: 12 }}>

                    <strong className="">New Invoice</strong>

                    <Row className="mt-3 align-items-center">
                        <Col xs={2}><span className="">Client</span></Col>
                        <Col xs={7}>
                            <SelectList search placeholder="Select Client" value={invoiceData.client_id} onChange={({ target }) => this.selectClient(target.value)}>
                                {clientList.map(client => <option key={client.client_id} value={client.client_id}>{client.client_name}</option>)}
                            </SelectList>
                        </Col>
                        {invoiceData.client_id &&
                            <Col xs={3}>
                                <input className="mr-3 align-middle" type="checkbox" value={invoiceData.isCreditNote} checked={invoiceData.isCreditNote} onChange={(e) => this.onChangeInvoiceData("isCreditNote", e.target.checked)} />
                                <span>Its a credit note ?</span>
                            </Col>
                        }
                    </Row>
                    {
                        !!invoiceData.isCreditNote &&
                        <Row className="mt-2 align-items-center">
                            <Col xs={2}><span className="">Reference Invoice</span></Col>
                            <Col xs={7}>
                                <SelectList search placeholder="Select Reference Invoice" value={invoiceData.credit_note_invoice_id} onChange={(e) => this.onChangeInvoiceData("credit_note_invoice_id", e.target.value)}>
                                    {clientInvoices.map(invoice => <option key={invoice.invoice_id} value={invoice.invoice_id}>{invoice.serial_number} (&#x20B9;{invoice.total_amount / 100})</option>)}
                                </SelectList>
                            </Col>
                        </Row>
                    }
                    <Row className="mt-3 align-items-center">
                        <Col xs={9}>
                            <Row className=" align-items-center" noGutters>
                                <Col xs={3}><span className="">Bill To</span></Col>
                                <Col xs={9}><InputField disabled placeholder="Business Name" value={selectedClient.business_name} /></Col>
                            </Row>
                            <Row className="mt-3 align-items-center" noGutters>
                                <Col xs={3}><span className="">Address</span></Col>
                                <Col xs={9}><InputField disabled placeholder="Business Address" value={selectedClient.address ? (selectedClient.address + (selectedClient.state ? ", " + selectedClient.state : "")) : ""} /></Col>
                            </Row>
                        </Col>
                        <Col xs={3}><img style={{ width: "75%" }} src={selectedClient.logo_url || DummyCompanyImage} alt="company" /></Col>
                    </Row>
                    <Row className="mt-3 align-items-center">
                        <Col xs={2}><span className="">Duration</span></Col>
                        <Col xs={4}>
                            <ReactDatePicker
                                selected={invoiceData.start_date ? moment(invoiceData.start_date).toDate() : null}
                                onChange={(dates) => this.onChangeInvoiceData("dates", dates)}
                                startDate={invoiceData.start_date ? moment(invoiceData.start_date).toDate() : null}
                                endDate={invoiceData.end_date ? moment(invoiceData.end_date).toDate() : null}
                                minDate={invoiceData.start_date ? moment(invoiceData.start_date).toDate() : false}
                                // shouldCloseOnSelect={!(!invoiceData.start_date || Boolean(invoiceData.start_date && invoiceData.end_date))}
                                selectsRange={true}
                                isClearable={true}
                                placeholderText="Select Date"
                                customInput={<div><input value={`${invoiceData.start_date ? moment(invoiceData.start_date).format("Do MMM'YY") : ""} - ${invoiceData.end_date ? moment(invoiceData.end_date).format("Do MMM'YY") : ""}`} /></div>}
                            />
                        </Col>
                        <Col xs={2}><span className="">Created On</span></Col>
                        <Col xs={4}>
                            <ReactDatePicker
                                selected={invoiceData.invoice_date ? moment(invoiceData.invoice_date).toDate() : null}
                                onChange={date => this.onChangeInvoiceData("invoice_date", date)}
                                dateFormat='dd-MMM-yyyy'
                                placeholderText="Select Date"
                                isClearable
                            />
                        </Col>
                    </Row>
                    <Row className="mt-3 align-items-center">
                        <Col xs={2}><span className="">GSTIN</span></Col>
                        <Col xs={4}><InputField disabled placeholder="GST Code" value={selectedClient.gst_no} /></Col>
                        <Col xs={2}><span className="">HSN Code</span></Col>
                        <Col xs={4}><InputField placeholder="HSN Code" onChange={(e) => this.onChangeInvoiceData("hsn_code", e.target.value)} value={invoiceData.hsn_code} /></Col>
                    </Row>
                    {/* <Row className="mt-3 align-items-center">
                <Col xs={2}><span className="">Place of Supply</span></Col>
                <Col xs={4}><InputField disabled placeholder="State" value={selectedClient.state} /></Col>
                <Col xs={2}><span className="">Contact</span></Col>
                <Col xs={4}><InputField disabled placeholder="Contact" value={selectedClient.contact} /></Col>
            </Row>
            */}
                    <Row className="px-4 mt-3 align-items-center font-weight-bold text-muted" style={{ fontSize: 11, letterSpacing: 0.5 }}>
                        <Col xs={7}><span className="">SELECT ITEM</span></Col>
                        <Col xs={2} className="text-center"><span className="">UNIT COST</span></Col>
                        <Col xs={3} className="text-center"><span className="">ONBOARDINGS</span></Col>
                    </Row>
                    <div className="mt-2 px-3 py-2 border bg-light shadow-sm" style={{ borderRadius: 12, maxHeight: 420, overflowY: "auto", overflowX: "hidden", position: "relative" }}>
                        {(invoiceData.items || []).map((item, i) => {
                            const totalUsers = (item.monthly_items || []).reduce((acc, m) => acc + (parseInt(m.user_onboarding) || 0), 0);
                            const displayUnitCost = (item.monthly_items && item.monthly_items.length > 0)
                                ? this.getMostOccurringUnitCost(item.monthly_items)
                                : (parseFloat(item.rate_per_item) || 0);
                            const monthsFromDuration = this.getMonthsList(invoiceData.start_date, invoiceData.end_date);
                            const candidateMonths = (monthsFromDuration && monthsFromDuration.length > 0)
                                ? monthsFromDuration
                                : this.getCandidateMonths(invoiceData.start_date, invoiceData.end_date);

                            return (
                                <div key={i} className="mb-3 border rounded bg-white shadow-sm overflow-hidden" style={{ borderRadius: 10 }}>
                                    {/* Top header & Invoice Description text box section with subtle accent background */}
                                    <div className="p-3 border-bottom" style={{ backgroundColor: "rgba(220, 53, 69, 0.09)", borderLeft: "4px solid #dc3545" }}>
                                        <Row className="align-items-center mb-2">
                                            <Col xs={7}>
                                                <span className="font-weight-bold text-dark">{i + 1}. Invoice Description</span>
                                            </Col>
                                            <Col xs={5} className="text-right d-flex align-items-center justify-content-end">
                                                <div className="mr-3 text-right">
                                                    <span className="d-block text-muted" style={{ fontSize: 9, fontWeight: 700, letterSpacing: 0.5 }}>UNIT COST</span>
                                                    <span className="font-weight-bold text-secondary">{displayUnitCost.toFixed(2)}</span>
                                                </div>
                                                <div className="mr-3 text-right">
                                                    <span className="d-block text-muted" style={{ fontSize: 9, fontWeight: 700, letterSpacing: 0.5 }}>TOTAL USERS</span>
                                                    <span className="font-weight-bold text-secondary">{totalUsers}</span>
                                                </div>
                                                <Icon style={{ fontSize: 18 }} className="text-muted clickable ml-2" onClick={() => this.removeInvoiceItem(item, i)}>delete</Icon>
                                            </Col>
                                        </Row>

                                        {/* Invoice Description Input */}
                                        <Row className="mb-0">
                                            <Col xs={8}>
                                                <InputField
                                                    placeholder="Invoice Description"
                                                    value={item.item_name || ""}
                                                    onChange={(e) => this.onChangeInvoiceItem(i, "item_name", e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Monthly Sub-rows & Add Item section with clean white background */}
                                    <div className="p-3 bg-white">
                                        {(item.monthly_items && item.monthly_items.length > 0) ?
                                            item.monthly_items.map((mItem, mIdx) => (
                                                <Row key={mIdx} className="align-items-center my-3 py-1">
                                                    <Col xs={3} className="px-2" style={{ position: "relative" }}>
                                                        <div>
                                                            <SelectList
                                                                search={true}
                                                                placeholder="Select Month"
                                                                value={mItem.month_label}
                                                                onChange={(e) => this.onChangeMonthlyItem(i, mIdx, "month_label", e.target.value)}
                                                            >
                                                                {candidateMonths.map(mLabel => {
                                                                    const isMonthAlreadyAddedForThisProject = (mItem.entity_id !== undefined && mItem.entity_id !== "") && (item.monthly_items || []).some((m, idx) =>
                                                                        idx !== mIdx &&
                                                                        m.month_label === mLabel &&
                                                                        (
                                                                            (mItem.entity_type === "GENERAL" || mItem.entity_id === 0)
                                                                                ? (m.entity_type === "GENERAL" || m.entity_id === 0)
                                                                                : String(m.entity_id) === String(mItem.entity_id)
                                                                        )
                                                                    );
                                                                    return (
                                                                        <option key={mLabel} value={mLabel} disabled={isMonthAlreadyAddedForThisProject}>
                                                                            {mLabel}{isMonthAlreadyAddedForThisProject ? " (Added)" : ""}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </SelectList>
                                                            {mItem.month_label && (
                                                                <div style={{ position: "absolute", right: 24, top: 4, zIndex: 2 }}>
                                                                    <ReactDatePicker
                                                                        selected={mItem.start_date ? moment(mItem.start_date).toDate() : null}
                                                                        onChange={(dates) => this.onChangeMonthDateRange(i, mIdx, dates)}
                                                                        startDate={mItem.start_date ? moment(mItem.start_date).toDate() : null}
                                                                        endDate={mItem.end_date ? moment(mItem.end_date).toDate() : null}
                                                                        selectsRange={true}
                                                                        minDate={moment(mItem.month_label, "MMM 'YY").startOf("month").toDate()}
                                                                        maxDate={moment(mItem.month_label, "MMM 'YY").endOf("month").toDate()}
                                                                        popperProps={{ positionFixed: true }}
                                                                        popperPlacement="bottom-start"
                                                                        customInput={
                                                                            <Icon
                                                                                style={{ fontSize: 16, cursor: "pointer" }}
                                                                                className="text-muted"
                                                                                title="Edit date range"
                                                                            >edit</Icon>
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                            {/* Date range label positioned absolutely below to maintain same baseline for all fields */}
                                                            {mItem.start_date && mItem.end_date && (
                                                                <div style={{ position: "absolute", top: "100%", left: 8, fontSize: 10, color: "#888", whiteSpace: "nowrap", zIndex: 1, marginTop: 1 }}>
                                                                    {moment(mItem.start_date).format("D MMM")} - {moment(mItem.end_date).format("D MMM")}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col xs={3} className="px-2">
                                                        <SelectList
                                                            search={true}
                                                            placeholder="Select Project"
                                                            value={mItem.entity_type === "GENERAL" || mItem.entity_id === 0 ? "GENERAL" : mItem.entity_id}
                                                            onChange={(e) => this.onChangeMonthlyItem(i, mIdx, "entity_id", e.target.value)}
                                                        >
                                                            {[
                                                                ...(this.state.jobList || []).map(job => {
                                                                    const isProjectAlreadyAddedForThisMonth = !!mItem.month_label && (item.monthly_items || []).some((m, idx) =>
                                                                        idx !== mIdx &&
                                                                        m.month_label === mItem.month_label &&
                                                                        m.entity_type !== "GENERAL" &&
                                                                        String(m.entity_id) === String(job.job_id)
                                                                    );
                                                                    return (
                                                                        <option key={job.job_id} value={job.job_id} disabled={isProjectAlreadyAddedForThisMonth}>
                                                                            {job.Employer ? job.Employer.employer_name + " - " + job.title : job.title}{isProjectAlreadyAddedForThisMonth ? " (Added)" : ""}
                                                                        </option>
                                                                    );
                                                                }),
                                                                (() => {
                                                                    const isGeneralAlreadyAddedForThisMonth = !!mItem.month_label && (item.monthly_items || []).some((m, idx) =>
                                                                        idx !== mIdx &&
                                                                        m.month_label === mItem.month_label &&
                                                                        (m.entity_type === "GENERAL" || m.entity_id === 0)
                                                                    );
                                                                    return (
                                                                        <option key="GENERAL" value="GENERAL" disabled={isGeneralAlreadyAddedForThisMonth}>
                                                                            General Entry{isGeneralAlreadyAddedForThisMonth ? " (Added)" : ""}
                                                                        </option>
                                                                    );
                                                                })()
                                                            ]}
                                                        </SelectList>
                                                    </Col>
                                                    <Col xs={2} className="px-2">
                                                        <InputField
                                                            type="number"
                                                            placeholder="Cost"
                                                            value={mItem.unit_cost || ""}
                                                            onChange={(e) => this.onChangeMonthlyItem(i, mIdx, "unit_cost", parseFloat(e.target.value) || 0)}
                                                        />
                                                    </Col>
                                                    <Col xs={2} className="px-2">
                                                        <InputField
                                                            type="number"
                                                            placeholder="Users"
                                                            value={mItem.user_onboarding || ""}
                                                            onChange={(e) => this.onChangeMonthlyItem(i, mIdx, "user_onboarding", parseInt(e.target.value) || 0)}
                                                        />
                                                    </Col>
                                                    <Col xs={2} className="pl-2 text-right d-flex align-items-center justify-content-end">
                                                        <span className="font-weight-bold text-dark mr-2">
                                                            &#x20B9; {((mItem.user_onboarding || 0) * (mItem.unit_cost || 0)).toLocaleString()}
                                                        </span>
                                                        <Icon style={{ fontSize: 16 }} className="text-muted clickable" onClick={() => this.removeMonthlyItem(i, mIdx)}>delete</Icon>
                                                    </Col>
                                                </Row>
                                            ))
                                            :
                                            <Row className="align-items-center my-3">
                                                <Col xs={4} className="px-2">
                                                    <SelectList
                                                        search={true}
                                                        placeholder="Select Project"
                                                        value={item.entity_type === "GENERAL" || item.entity_id === 0 ? "GENERAL" : item.entity_id}
                                                        onChange={(e) => this.onChangeInvoiceItem(i, "entity_id", e.target.value)}
                                                    >
                                                        {[
                                                            ...(this.state.jobList || []).map(job => (
                                                                <option key={job.job_id} value={job.job_id}>
                                                                    {job.Employer ? job.Employer.employer_name + " - " + job.title : job.title}
                                                                </option>
                                                            )),
                                                            <option key="GENERAL" value="GENERAL">General Entry</option>
                                                        ]}
                                                    </SelectList>
                                                </Col>
                                                <Col xs={3} className="px-2">
                                                    <InputField
                                                        type="number"
                                                        placeholder="Cost"
                                                        value={item.rate_per_item || ""}
                                                        onChange={(e) => this.onChangeInvoiceItem(i, "rate_per_item", parseFloat(e.target.value) || 0)}
                                                    />
                                                </Col>
                                                <Col xs={3} className="px-2">
                                                    <InputField
                                                        type="number"
                                                        placeholder="Users"
                                                        value={item.quantity || ""}
                                                        onChange={(e) => this.onChangeInvoiceItem(i, "quantity", parseInt(e.target.value) || 0)}
                                                    />
                                                </Col>
                                                <Col xs={2} className="pl-2 text-right">
                                                    <span className="font-weight-bold text-dark mr-2">
                                                        &#x20B9; {((item.quantity || 0) * (item.rate_per_item || 0)).toLocaleString()}
                                                    </span>
                                                </Col>
                                            </Row>
                                        }

                                        {/* + Add Item Button */}
                                        <div className="mt-2 pt-1">
                                            <span
                                                className="clickable text-primary font-weight-bold d-inline-flex align-items-center"
                                                style={{ fontSize: 12, cursor: "pointer" }}
                                                onClick={() => this.addMonthToItem(i)}
                                            >
                                                <Icon style={{ fontSize: 16 }} className="mr-1">add_circle_outline</Icon> Add Item
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}

                        <div className="text-center mt-3 mb-2">
                            {!!selectedClient.client_id && <Icon className="align-middle border clickable bg-white shadow-sm" style={{ borderRadius: 10, width: 100, fontSize: 20 }} onClick={() => this.appendNewInvoiceItem()}>add</Icon>}
                        </div>
                    </div>
                    <Row className="mt-3 align-items-center">
                        <Col xs={2}><span className="">Total Amount</span></Col>
                        <Col xs={4}><InputField disabled placeholder="10000" value={invoiceData.taxable_amount || 0} /></Col>
                        {/* <Col xs={2}><span className="">Due Date</span></Col>
                <Col xs={2}>
                    <ReactDatePicker
                        selected={invoiceData.expiry_date || null}
                        onChange={date => this.onChangeInvoiceData("expiry_date", date)}
                        placeholder="Select Date"
                        dateFormat='dd-MMM-yyyy'
                        isClearable
                    />
                </Col> */}
                        <Col xs={6}><input className="align-middle" type="checkbox" checked={invoiceData.tax_reverse_charge} onChange={(e) => this.onChangeInvoiceData("tax_reverse_charge", e.target.checked)} /> <span>Whether Tax payable under reverse charge</span></Col>
                    </Row>
                    <Row className="mt-3 align-items-center">
                        <Col xs={2}><span className="">Email To</span></Col>
                        <Col xs={4} title={selectedClient.email}><InputField disabled value={selectedClient.email} placeholder="Client Email" /></Col>
                        <Col xs={6}><input className="align-middle" type="checkbox" checked={invoiceData.isIncludeSign} onChange={(e) => this.onChangeInvoiceData("isIncludeSign", e.target.checked)} /> <span>Is include signature in Invoice?</span></Col>
                        {/* <Col xs={2}><span className="">Our GSTIN</span></Col> */}
                        {/* <Col xs={4}>
                    <SelectList search placeholder="Select our GST" value={invoiceData.primaryGST} onChange={(e) => this.onChangeInvoiceData("primaryGST", e.target.value)}>
                        <option value={1}>Delhi - 07AAICR3777Q1ZG</option>
                        <option value={2}>Haryana - 06AAICR3777Q1ZI</option>
                    </SelectList>
                </Col> */}
                    </Row>
                    <Row className="mt-3 align-items-center">
                        <Col xs={2}><span className="">Email CC</span></Col>
                        <Col xs={10}><InputField value={invoiceData.cc} onChange={(e) => this.onChangeInvoiceData("cc", e.target.value)} placeholder="Add multiple email IDs with comma" /></Col>
                    </Row>
                    <Row className="mt-3 align-items-center">
                        <Col xs={2}><span className="">Attachment File</span></Col>
                        <Col xs={4}><input type="file" value={invoiceData.attachment_file && invoiceData.attachment_file.file_name} onChange={(e) => this.onChangeInvoiceData("attachment_file", e.target.files[0])} placeholder="Add Attachment File" /></Col>
                    </Row>
                </main>
                <footer style={{ flex: 0, position: "sticky", bottom: 0, background: "#fff", marginLeft: -15, marginRight: -15 }} className="px-3 w-100">
                    <Row className="align-items-center justify-content-end py-3 border-top mt-3">
                        <Col xs={3}>
                            <Button className="w-100 text-danger border-danger" variant="outlined" color="secondary" style={{ borderRadius: 25 }} onClick={() => this.props.onClose()}>Cancel</Button>
                        </Col>
                        <Col xs={3}>
                            <Button disabled={!invoiceData.taxable_amount || (invoiceData.items || []).some(item => !item.item_name || !item.item_name.trim())} onClick={() => this.previewInvoice()} className="w-100 bg-danger" variant="contained" color="secondary" style={{ borderRadius: 25 }}>Preview</Button>
                        </Col>
                    </Row>
                </footer>

                <ConfirmAction message={this.state.isConfirmMessage} isOpen={!!this.state.isConfirm} onClose={() => this.setState({ isConfirm: false })} callback={this.state.isConfirm} />

            </div>
        )
    }


}


export default InvoiceCreate;
